import { createFileRoute } from '@tanstack/react-router';

import { PackagesPage } from '@/features/subcontracts/packages-page';

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/packages/')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <PackagesPage projectId={projectId} />;
}
